// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1506":"632c8f6a","4221":"632c8f6a","4415":"632c8f6a","6346":"b72a8383","7738":"624ad35b","8015":"16c3c7cc","9623":"7a10714c"}[chunkId] + ".chunk.css";
};